module.exports = __webpack_public_path__ + "img/OVCA_Myofibroblasts.76d50569.png";